import React from 'react';
import ENetsPaymentInterimResult from '../../modules/payment/components/ENetsPaymentInterimResult';

const ENetsPaymentInterimResultPage = () => (
  <>
    <ENetsPaymentInterimResult />
  </>
);

export default ENetsPaymentInterimResultPage;
